export class TimerManager {
  private timers = new Set<number>();

  timeout(callback: () => void, delay: number): number {
    const id = window.setTimeout(() => { this.timers.delete(id); callback(); }, delay);
    this.timers.add(id);
    return id;
  }

  interval(callback: () => void, delay: number): number {
    const id = window.setInterval(callback, delay);
    this.timers.add(id);
    return id;
  }

  clear(id: number): void { window.clearTimeout(id); window.clearInterval(id); this.timers.delete(id); }
  clearAll(): void { this.timers.forEach((id) => { window.clearTimeout(id); window.clearInterval(id); }); this.timers.clear(); }
}
